import {createContext} from 'react';

import {MultiPoint} from 'ol/geom';
import {Circle, Fill, Stroke, Style} from 'ol/style';

import {useVectorLayer, useVectorSource} from './OpenLayers/hooks';

export const LengthContext = createContext(null);
export const DrawingContext = createContext(null);

const getCoordinate = feature => feature.getGeometry().getCoordinates()[0];

const geometry = feature => new MultiPoint(getCoordinate(feature));

const LayerStyle = [
    // Lines
    new Style({
        stroke: new Stroke({
            color: 'blue',
            width: 2,
        }),
        fill: new Fill({
            color: 'rgba(0, 0, 255, 0.1)',
        }),
    }),
    // Corners
    new Style({
        image: new Circle({
            radius: 8,
            fill: new Fill({
                color: 'white',
            }),
        }),
        geometry,
    }),
    new Style({
        image: new Circle({
            radius: 5,
            fill: new Fill({
                color: 'orange',
            }),
        }),
        geometry,
    }),
];

const useDrawing = zIndex => {
    const drawing = useVectorSource({wrapX: false}, []);

    useVectorLayer({source: drawing, style: LayerStyle, zIndex}, [drawing]);

    return drawing;
};

export default useDrawing;
